var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-section-navigation',
    {
      'dp-section-navigation--minimised': _vm.state.isMinimised,
    }
  ]},_vm._l((_vm.sections),function(section){return _c(section.routeName ? 'router-link' : 'div',{directives:[{name:"show",rawName:"v-show",value:(section.visible !== false),expression:"section.visible !== false"}],key:section.name,tag:"component",class:[
      'dp-section-navigation__section',
      {
        'dp-section-navigation__section--with-children': !!section.children,
      }
    ],attrs:{"to":{ name: section.routeName }}},[_c('div',{class:[
        'dp-section-navigation__top-level',
        {
          'dp-section-navigation__top-level--active': section.routeName === _vm.$route.name
            || _vm.$route.meta && _vm.$route.meta.section === section.name,
        }
      ],on:{"click":function($event){return _vm.toggleSection(section)}}},[_c('dp-icon',{attrs:{"name":section.icon}}),_c('span',{staticClass:"dp-section-navigation__top-level-label"},[_vm._v(_vm._s(section.name))]),(section.children)?_c('div',{class:[
          'dp-section-navigation__top-level-toggle',
          {
            'dp-section-navigation__top-level-toggle--open':
              _vm.state[section.name] && _vm.state[section.name].open === true,
          } ]}):_vm._e()],1),(section.children)?_c('div',{class:[
        'dp-section-navigation__children',
        {
          'dp-section-navigation__children--open':
            _vm.state[section.name] && _vm.state[section.name].open === true,
        }
      ]},[_c('span',{staticClass:"dp-section-navigation__children-title"},[_vm._v(" "+_vm._s(section.name)+" ")]),_vm._l((section.children),function(child){return _c('router-link',{directives:[{name:"show",rawName:"v-show",value:(child.visible !== false),expression:"child.visible !== false"}],key:child.name,class:[
          'dp-section-navigation__child-link',
          {
            'dp-section-navigation__child-link--active': _vm.$route.name === child.routeName,
          }
        ],attrs:{"to":{ name: child.routeName }}},[_c('dp-icon',{attrs:{"name":child.icon}}),_c('span',[_vm._v(_vm._s(child.name))])],1)})],2):_vm._e()])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }